export default __webpack_public_path__ + "7a1e8bb2351167dbc6a047c3961e4c6f.png";